export default function AuthorUpdates() {
  const updates = [
    {
      date: 'March 15, 2024',
      title: 'Book Tour Announcement',
      excerpt: 'Excited to announce my upcoming book tour across major cities. Join me for readings, signings, and intimate conversations about the craft of storytelling.',
      image: 'https://public.readdy.ai/ai/img_res/c98beb37b3b583047316cfc761134295.jpg'
    },
    {
      date: 'February 28, 2024',
      title: 'New Novel in Progress',
      excerpt: 'Currently working on my sixteenth novel, a sweeping historical epic set in post-war Europe. The research has taken me to archives across three continents.',
      image: 'https://readdy.ai/api/search-image?query=writer%20working%20on%20manuscript%20at%20vintage%20desk%20with%20papers%20and%20coffee%20creative%20writing%20process%20atmospheric%20study%20room%20with%20natural%20light%20focused%20work%20environment%20simple%20background&width=800&height=450&seq=update-002&orientation=landscape'
    },
    {
      date: 'January 20, 2024',
      title: 'Literary Award Recognition',
      excerpt: 'Honored to receive the Distinguished Achievement Award from the International Writers Association. Grateful for this recognition and the continued support of readers.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20literary%20award%20ceremony%20with%20trophy%20and%20formal%20event%20setting%20sophisticated%20atmosphere%20professional%20recognition%20event%20warm%20ambient%20lighting%20simple%20clean%20background&width=800&height=450&seq=update-003&orientation=landscape'
    },
    {
      date: 'December 10, 2023',
      title: 'Writing Workshop Series',
      excerpt: 'Launching a new online workshop series for aspiring writers. Learn the techniques and strategies that have shaped my approach to storytelling over the years.',
      image: 'https://readdy.ai/api/search-image?query=author%20teaching%20writing%20workshop%20in%20cozy%20classroom%20setting%20with%20students%20engaged%20learning%20environment%20books%20and%20notebooks%20warm%20educational%20atmosphere%20simple%20background&width=800&height=450&seq=update-004&orientation=landscape'
    },
    {
      date: 'November 5, 2023',
      title: 'Featured Interview',
      excerpt: 'My latest interview with Literary Review Magazine is now available. We discuss the inspiration behind my recent work and the future of contemporary fiction.',
      image: 'https://readdy.ai/api/search-image?query=professional%20author%20interview%20setup%20with%20microphone%20and%20elegant%20studio%20lighting%20sophisticated%20media%20appearance%20literary%20discussion%20setting%20clean%20simple%20background&width=800&height=450&seq=update-005&orientation=landscape'
    }
  ];

  const purchaseLinks = [
    {
      name: 'Amazon',
      url: 'https://www.amazon.com/Gen-1-Richard-Pontefract/dp/1967361444',
      icon: 'ri-amazon-line',
      color: 'bg-[#FF9900] hover:bg-[#E68A00]'
    },
    {
      name: 'Barnes & Noble',
      url: 'https://www.barnesandnoble.com',
      icon: 'ri-book-line',
      color: 'bg-[#2C5F2D] hover:bg-[#234A24]'
    },
    {
      name: 'Apple Books',
      url: 'https://books.apple.com',
      icon: 'ri-apple-line',
      color: 'bg-[#000000] hover:bg-[#1A1A1A]'
    },
    {
      name: 'Google Books',
      url: 'https://books.google.com',
      icon: 'ri-google-line',
      color: 'bg-[#4285F4] hover:bg-[#3367D6]'
    },
    {
      name: 'Kobo',
      url: 'https://www.kobo.com',
      icon: 'ri-book-open-line',
      color: 'bg-[#E4405F] hover:bg-[#D32F4F]'
    }
  ];

  return (
    <section id="updates" className="py-32 px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#C9A961]"></div>
            <span className="text-xs uppercase tracking-widest text-[#6B6B6B]">Latest Updates</span>
          </div>
          <h2 className="text-6xl font-bold text-[#2C2C2C] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Stay Connected
          </h2>
          <p className="text-lg text-[#6B6B6B]">
            Follow my writing journey, book tours, and literary insights
          </p>
        </div>

        {/* Purchase Links Section */}
        <div className="mb-20 bg-gradient-to-br from-[#F5F5F5] to-[#ECECEC] rounded-3xl p-12">
          <div className="text-center mb-10">
            <h3 className="text-4xl font-bold text-[#2C2C2C] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
              Get Your Copy of Gen 1
            </h3>
            <p className="text-base text-[#6B6B6B]">
              Available now at your favorite bookstore
            </p>
          </div>
          <div className="grid grid-cols-5 gap-6 max-w-5xl mx-auto">
            {purchaseLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${link.color} text-white rounded-2xl p-6 flex flex-col items-center justify-center gap-3 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer`}
              >
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className={`${link.icon} text-3xl`}></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">{link.name}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="flex gap-8 overflow-x-auto pb-8 scrollbar-hide">
          {updates.map((update, index) => (
            <div 
              key={index}
              className="flex-shrink-0 w-[420px] bg-white rounded-2xl border border-[#E5E5E5] transition-all duration-300 hover:shadow-xl cursor-pointer"
              style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}
            >
              <div className="p-6">
                <div className="inline-flex items-center px-4 py-2 bg-[#D4E5D4] rounded-full mb-4">
                  <span className="text-xs text-[#2C2C2C] font-medium whitespace-nowrap">{update.date}</span>
                </div>
                <div className="w-full h-[240px] mb-6 rounded-xl overflow-hidden">
                  <img 
                    src={update.image}
                    alt={update.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">
                  {update.title}
                </h3>
                <p className="text-base text-[#6B6B6B] leading-relaxed mb-6 line-clamp-3">
                  {update.excerpt}
                </p>
                <button className="flex items-center gap-2 text-[#C9A961] font-medium hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  <span>Read More</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
